import Session from "Session";
import _ from "underscore";
import saveFavorites from "./save-favorites";
import fetchPresets from "./fetch-presets";
import saveTagsConfigurations from "./save-tags-configurations";
const PRESETS_ORDER = {
    active: 0,
    drafts: 1,
    everything: 3,
};
export class PresetsConfigurationsMutable {
    constructor(presets) {
        this.userId = Session.getInstance().getUserId();
        this.clientId = Session.getInstance().getClientId();
        this.presets = presets.sort((preset1, preset2) => {
            return PRESETS_ORDER[preset1.name] - PRESETS_ORDER[preset2.name];
        });
    }
    addPreset(value) {
        const preset = _.reduce(value, (acc, data, key) => {
            acc[key] = key === "name" ? data : data.value;
            return acc;
        }, {});
        this.presets.push(preset);
    }
    remove(value) {
        this.presets = _.reject(this.presets, (preset) => preset.name === value);
    }
}
export class FavoritesConfigurationsMutable {
    constructor(favorites) {
        this.userId = Session.getInstance().getUserId();
        this.clientId = Session.getInstance().getClientId();
        this.favorites = [...favorites];
    }
    updateFavorites(name) {
        if (_.contains(this.favorites, name)) {
            this.favorites = _.without(this.favorites, name);
        }
        else {
            this.favorites.push(name);
        }
    }
    getFavorites() {
        return this.favorites;
    }
}
export class TagConfigurationsMutable {
    constructor(tagsConfiguration) {
        this.userId = Session.getInstance().getUserId();
        this.clientId = Session.getInstance().getClientId();
        this.tagsConfiguration = tagsConfiguration;
    }
    updateConfiguration(field, value) {
        this.tagsConfiguration[field] = value;
    }
    getConfiguration(field) {
        return this.tagsConfiguration[field];
    }
}
export default {
    fetchPresets,
    saveFavorites,
    saveTagsConfigurations,
};
